<template>
    <div class="flex">
        <div class="w-full bg-white shadow">
            <div class="relative" style="padding-bottom: 100%">
                <img
                    class="absolute h-full w-full object-cover "
                    :src="event.gsx$posterimage.$t ? event.gsx$posterimage.$t : defaultImg"
                    alt=""
                />
            </div>
            <div class="p-2 overflow-hidden">
                <div class="font-semibold flex justify-between text-xs text-gray-600">
                    <div class="flex">
                        <svg
                            class="mr-1 h-4 w-4"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path
                                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                            ></path>
                        </svg>
                        {{ displayDate(event.gsx$datetimestart.$t) }}
                    </div>
                    <div class="flex">
                        <svg
                            class="h-4 w-4 min-h-4 min-w-4 mr-1"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                            <path d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                        </svg>
                        <time>
                            {{ displayTime(event.gsx$datetimestart.$t) }}
                        </time>
                        <span class="mx-1" v-if="event.gsx$datetimeend.$t">
                            -
                        </span>
                        <time v-if="event.gsx$datetimeend.$t">
                            {{ displayTime(event.gsx$datetimeend.$t) }}
                        </time>
                    </div>
                </div>
                <h3 class="mt-2 text-xl leading-7 font-semibold text-gray-900">
                    {{ event.gsx$eventname.$t }}
                </h3>
                <div
                    v-if="event.gsx$organizers.$t"
                    class="mt-1 flex items-center text-gray-600 whitespace-normal"
                >
                    <p class="text-sm overflow-hidden">Organizer: {{ event.gsx$organizers.$t }}</p>
                </div>
                <p class="mt-2 text-xs leading-2 text-gray-600">
                    {{ event.gsx$organizertext.$t }}
                </p>

                <div class="mt-2 flex items-center text-gray-600 truncate">
                    <svg
                        class="mr-1 h-4 w-4 text-gray-600 min-w-4 min-h-4"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                    >
                        <path
                            d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    </svg>
                    <a class="overflow-hidden" :href="event.gsx$locationgeo.$t">{{
                        event.gsx$locationgeo.$t
                    }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['event'],
    name: 'EventCard',
    data() {
        return {
            defaultImg: '../blm.png',
        }
    },
    methods: {
        displayDate: function(date) {
            let d = new Date(date.replace(/-/g, '/'))
            let day = d.getDate()
            let month = d.getMonth()
            if (isNaN(day) || isNaN(month)) {
                return '-'
            }
            return month + 1 + '/' + day
        },
        toggleMap: function() {
            this.mapView = !this.mapView
        },
        displayTime: function(date) {
            let d = new Date(date.replace(/-/g, '/'))
            let hours = d.getHours()
            if (hours > 12) {
                hours = hours - 12
            }
            let minutes = d.getMinutes()
            if (minutes < 10) {
                minutes = '0' + minutes
            }
            if (isNaN(hours)) {
                hours = '00'
            }
            if (isNaN(minutes)) {
                minutes = '00'
            }
            return hours + ':' + minutes
        },
    },
}
</script>
